import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
} from '@material-ui/core/';

import PersonIcon from '@material-ui/icons/Person';
import { Admin } from '../../../store/types';

interface IProp {
  item: Admin
  select: Function
}

export default ({ item, select }: IProp) => (
  <ListItem
    disableRipple
    key={item.username}
    button
    divider
    selected={item.selected}
    onClick={() => select(item)}
  >
    <ListItemAvatar>
      <ListItemAvatar>
        <Avatar alt={item.email}>
          <PersonIcon />
        </Avatar>
      </ListItemAvatar>
    </ListItemAvatar>
    <ListItemText
      primary={<Typography variant="caption" component="span">{item.email}</Typography>}
      secondary={<Typography variant="caption" component="span" sx={{ display: 'block', fontSize: '0.55rem' }}>{item.createdDate}</Typography>}
    />
  </ListItem>
);
